export default __webpack_public_path__ + "static/media/Facebook.936a1511.svg";